import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureDashboardAttribution, initDashboardAnalytics, trackDashboardPageView } from "@/lib/analytics";

export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    initDashboardAnalytics();
    captureDashboardAttribution();
  }, []);

  useEffect(() => {
    trackDashboardPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return null;
}
